import * as React from 'react';
import * as _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import Pager2 from '../../../components/PageLayout/Pager2';
import CheckBox from '../../../components/PageLayout/CheckBox';
export default function () {
    function onChecked1(entities, intl, activeFabricatorIdJob, totalPages) {
        this.handleAllEntitiesCheck('isAssociated');
    }
    function onChecked2(entities, intl, activeFabricatorIdJob, totalPages) {
        this.handleAllEntitiesCheck('isLicensedAdmin');
    }
    function onChange3(entities, intl, activeFabricatorIdJob, totalPages, e) {
        this.handleSearchTextChanged(e);
    }
    function onChecked4(entities, intl, activeFabricatorIdJob, totalPages, entity, entityIndex, checked) {
        this.props.assignEntityPopupCheckName(entity.id, !checked);
    }
    function onChecked5(entities, intl, activeFabricatorIdJob, totalPages, entity, entityIndex, checked) {
        this.props.assignEntityPopupCheckIsLicensedAdmin(entity.id, !checked);
    }
    function repeatEntity6(entities, intl, activeFabricatorIdJob, totalPages, entity, entityIndex) {
        return React.createElement('li', { 'key': entity.id }, React.createElement('div', { 'className': 'table-cell' }, React.createElement('div', { 'className': 'fabricators-popup-row' }, React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement(CheckBox, {
            'text': entity.companyName || entity.name,
            'className': 'ui-svg-checkbox--flex',
            'checked': activeFabricatorIdJob ? activeFabricatorIdJob === entity.id : entity.isAssociated,
            'onChecked': onChecked4.bind(this, entities, intl, activeFabricatorIdJob, totalPages, entity, entityIndex),
            'type': 'small'
        })))), !this.state.hideLicensedAdminCheckBoxes ? React.createElement('div', {
            'className': 'table-cell',
            'key': '2948'
        }, React.createElement('div', { 'className': 'fabricators-popup-row' }, React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement(CheckBox, {
            'checked': entity.isLicensedAdmin,
            'className': 'ui-svg-checkbox--flex',
            'text': intl.formatMessage({ id: 'employees.licensedAdmin' }),
            'onChecked': onChecked5.bind(this, entities, intl, activeFabricatorIdJob, totalPages, entity, entityIndex),
            'type': 'small',
            'disabled': !entity.isAssociated
        })))) : null);
    }
    function onClick7(entities, intl, activeFabricatorIdJob, totalPages) {
        this.handleClose();
    }
    function onClick8(entities, intl, activeFabricatorIdJob, totalPages) {
        this.handleSave();
    }
    function scopeEntitiesIntlActiveFabricatorIdJobTotalPages9() {
        var entities = this.props.popup.get('allEntities').toJS();
        var intl = this.props.intl;
        var activeFabricatorIdJob = this.props.popup.get('activeFabricatorIdJob');
        var totalPages = this.props.popup.get('totalPages');
        return React.createElement('div', { 'className': 'fabricators-popup-container' }, React.createElement('div', { 'className': 'ui-popup' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.props.popup.get('headerText'))), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'permissions-panel' }, React.createElement('div', { 'className': 'fabricators-popup-row' }, React.createElement('div', { 'className': 'fabricators-popup-col permissions-panel__col--3' }, React.createElement(CheckBox, {
            'checked': this.allEntitiesChecked('isAssociated'),
            'text': 'Select All',
            'onChecked': onChecked1.bind(this, entities, intl, activeFabricatorIdJob, totalPages),
            'type': 'small'
        })), React.createElement('div', { 'className': 'fabricators-popup-col permissions-panel__col--5' }, React.createElement(CheckBox, {
            'checked': this.allEntitiesChecked('isLicensedAdmin'),
            'text': 'Licensed All',
            'disabled': !this.allEntitiesChecked('isAssociated'),
            'onChecked': onChecked2.bind(this, entities, intl, activeFabricatorIdJob, totalPages),
            'type': 'small'
        })), React.createElement('div', { 'className': 'fabricators-popup-col permissions-panel__col--4' }, React.createElement('input', {
            'type': 'text',
            'value': this.state.searchText,
            'className': 'generic-popup-textbox',
            'placeholder': intl.formatMessage({ id: 'assignPopup.searchPlaceholder' }),
            'onChange': onChange3.bind(this, entities, intl, activeFabricatorIdJob, totalPages)
        })))), React.createElement('div', { 'className': 'fabricators-popup-content fabricators-popup-content--with-panel' }, this.props.entitiesLoading ? React.createElement('div', {
            'style': { height: '290px' },
            'key': '2056'
        }, React.createElement('div', { 'className': 'ui-loader' })) : null, !this.props.entitiesLoading ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'ui-list',
                'key': '2189'
            },
            _.map(entities, repeatEntity6.bind(this, entities, intl, activeFabricatorIdJob, totalPages))
        ]) : null), React.createElement(Pager2, {
            'totalPages': totalPages,
            'page': this.state.page ? this.state.page - 1 : 0,
            'pageClick': this.handlePageClick
        })), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
            'className': 'ui-button ui-button--blue',
            'onClick': onClick7.bind(this, entities, intl, activeFabricatorIdJob, totalPages)
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, React.createElement(FormattedMessage, { 'id': 'messageBox.buttons.cancel' }))), React.createElement('button', {
            'className': 'ui-button ui-button--green',
            'onClick': onClick8.bind(this, entities, intl, activeFabricatorIdJob, totalPages)
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, React.createElement(FormattedMessage, { 'id': 'messageBox.buttons.save' }))))));
    }
    return scopeEntitiesIntlActiveFabricatorIdJobTotalPages9.apply(this, []);
}